/* eslint-disable class-methods-use-this */
import SimpleApi from 'SharedDir/backend/api/classes/simpleApi';
import { TTPRegistries } from 'SharedDir/declarations/ttp-registries';
import { TTP_ORGANIZATION, organiztionsUrl } from 'SharedDir/backend/endpoints/ttp-registries';
import { AxiosResponse } from 'axios';
import { http } from 'SharedDir/backend/axios/http';
import { Paginated, PaginationParams } from 'SharedDir/declarations/pagination';

export default class TtpOrganizationsApiClass extends SimpleApi<
  TTPRegistries.OrganizationFull,
  TTPRegistries.OrganizationFull,
  TTPRegistries.OrganizationFull,
  TTPRegistries.OrganizationBare
> {
  protected readonly organizationEndpoints = TTP_ORGANIZATION;

  public async exclude(
    id: number,
    data: TTPRegistries.OrganizationExclude
  ): Promise<TTPRegistries.OrganizationFull> {
    const endpoints = this.organizationEndpoints.EXCLUDE(id);
    const { data: responseData } = (await http({
      ...endpoints,
      data,
    })) as AxiosResponse<TTPRegistries.OrganizationFull>;
    return responseData;
  }

  constructor() {
    super(organiztionsUrl);
  }
}
